import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { API } from "../../../API";
import { isAutheticated } from "../../auth/authhelper";
import Footer from "../Footer";
import axios from "axios";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import OrderDetail from "./OrderDetail";

const OrderEdit = () => {
  const history = useHistory();
  const { token } = isAutheticated();
  const { status, id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [currency, setCurrency] = useState();
  const [newStatus, setNewStatus] = useState("");

  // --------------------------
  // Get Currency
  // --------------------------
  useEffect(() => {
    axios
      .get(`${API}/api/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => setCurrency(res.data.data.settings.currency))
      .catch((err) => console.log(err));
  }, [token]);

  // --------------------------
  // Fetch Order Details
  // --------------------------
  const loadOrder = () => {
    axios
      .get(`${API}/api/order/view_order/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data.data)
        setOrder(res.data.data);
        setNewStatus(res.data.data.orderStatus); // default selected
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadOrder();
  }, [token]);

  // --------------------------
  // Save Updated Order Status
  // --------------------------
  const saveHandler = () => {
    if (!newStatus) {
      swal("Select a status!", "", "error");
      return;
    }

    setIsLoading(true);

    axios
      .patch(
        `${API}/api/order/update-status/${id}`,
        { orderStatus: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        swal("Status Updated!", "", "success");
        setIsLoading(false);
        history.push(`/orders/${newStatus}`);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        swal("Something went wrong", "", "error");
      });
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">

          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Edit Order Details</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Orders</li>
                    <li className="breadcrumb-item active">Edit Order</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* SAVE / CANCEL */}
          <div className="row">
            <div className="col-12">
              <div className="form-group text-right">
                <button
                  type="button"
                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                  onClick={saveHandler}
                >
                  <ClipLoader loading={isLoading} size={18} />
                  {!isLoading && "Save"}
                </button>

                <Link to={`/orders/${status}`}>
                  <button
                    type="button"
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          </div>

          {/* ORDER DETAIL */}
          {order  && (
            <OrderDetail
              status={status}
              data={order}
              newStatus={newStatus}
              setNewStatus={setNewStatus}
              currency={currency}
            />
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OrderEdit;
